import React, { useState, useEffect } from "react";
import { Drawer, Input, List, Typography, Button, Spin, message } from "antd";
import { SearchOutlined, FileExcelOutlined, DownloadOutlined } from "@ant-design/icons";
import { useSelector } from 'react-redux';
import TemplatesAPI from "../../../../restAPI/TemplatesAPI";

const { Text } = Typography;

const FileListDrawer = ({ visible, onClose }) => {
  const { token } = useSelector(state => state.auth);
  const [templates, setTemplates] = useState([]);
  const [originalTemplates, setOriginalTemplates] = useState([]);
  const [downloadingTemplateId, setDownloadingTemplateId] = useState(null);

  useEffect(() => {
    if (visible) {
      // Always fetch fresh templates when drawer opens to get latest company/group
      getTemplateByGroupIdCompanyId();
    }
  }, [visible]);

  const getTemplateByGroupIdCompanyId = async () => {
    await TemplatesAPI.getTemplateByGroupIdCompanyId(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'))
      .then((res) => {
        if (res?.data && res.data.length > 0) {
          const rows = [];
          res.data.map((rowValue) => {
            rows.push({ _id: rowValue._id, name: rowValue.name, fileUrl: rowValue.fileUrl })
          });
          setTemplates(rows);
          setOriginalTemplates(rows);
        } else {
          // Clear templates if no data or empty array
          setTemplates([]);
          setOriginalTemplates([]);
        }
      }).catch(err => {
        console.log("error getting template data :", err.message);
        // Clear templates on error as well
        setTemplates([]);
        setOriginalTemplates([]);
      })
  };

  const onDownloadTemplate = async (templateId, fileName) => {
    setDownloadingTemplateId(templateId);
    try {
      // Use the new download API
      const response = await TemplatesAPI.downloadTemplateById(
        token, 
        localStorage.getItem('groupId'), 
        localStorage.getItem('companyId'), 
        templateId
      );
      
      // The response.data is already a blob when responseType: 'blob' is set
      if (response && response.data) {
        // Create a Blob URL from the response data
        const blobUrl = URL.createObjectURL(response.data);
        
        // Create download link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        console.log("Downloading file as:", fileName);
        
        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl); // Free up memory
        
        message.success('Template downloaded successfully!');
      } else {
        message.error('Failed to download template: No data received');
      }
    } catch (error) {
      console.error("Error downloading template:", error);
      message.error('Failed to download template. Please try again.');
    } finally {
      setDownloadingTemplateId(null);
    }
  }

  const onSearch = (value) => {
    if (value !== "") {
      const rows = [];
      originalTemplates.map((rowValue) => {
        if (rowValue.name.includes(value)) {
          rows.push({
            _id: rowValue._id, name: rowValue.name, fileUrl: rowValue.fileUrl
          })
        }
      });
      setTemplates(rows);
    }
    else {
      const rows = [];
      originalTemplates.map((rowValue) => {
        rows.push({ _id: rowValue._id, name: rowValue.name, fileUrl: rowValue.fileUrl })
      });
      setTemplates(rows);
    }
  }

  return (
    <Drawer
      title="Download Existing Template"
      width={700}
      visible={visible}
      onClose={onClose}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose} size="large" style={{ marginRight: 8 }}>
            Close
          </Button>
        </div>
      }
    >
      {/* Search Input */}
      <div style={{ marginBottom: "16px" }}>
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined />}
          size="large"
          onChange={(e) => onSearch(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
      </div>

      {/* File List */}
      <List
        dataSource={templates}
        renderItem={(item) => (
          <List.Item
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FileExcelOutlined style={{ color: "green", marginRight: 8 }} />
              <Text>{item.name}</Text>
            </div>
            <Button
              type="link"
              icon={downloadingTemplateId === item._id ? <Spin size="small" /> : <DownloadOutlined />}
              loading={downloadingTemplateId === item._id}
              onClick={() => onDownloadTemplate(item._id, item.name)}
              disabled={downloadingTemplateId === item._id}
            />
          </List.Item>
        )}
      />
    </Drawer>
  );
};

export default FileListDrawer;
